import CONSTANT from '../../constants'
import fetchWithAuthorizationHeader from '../../helper/fetchWithAuthorizationHeader'
import type { MultiTenantRejectionRequest } from '../../types/multiTenantRequest'

const { MULTI_TENANT_REQUESTS_API_URL } = CONSTANT

const rejectMultiTenantRequest = async (
	rejection: MultiTenantRejectionRequest
): Promise<any> => {
	const response = await fetchWithAuthorizationHeader(
		`${MULTI_TENANT_REQUESTS_API_URL}`,
		{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				action: 'REJECT'
			},
			body: JSON.stringify(rejection)
		}
	)
	return response.json()
}

export default rejectMultiTenantRequest
